// extracted by mini-css-extract-plugin
export default {"container":"WordGameLayout_container__wqTtK","sub_container":"WordGameLayout_sub_container__co0AF"};